import * as types from "@/redux/types";

const initialState = { show: false };

export const sendingReducer = (state = initialState, action) => {
    const { type } = action;

    switch (type) {
        case types.HIDE_SENDING_LOADER: return { show: false };

        case types.SHOW_SENDING_LOADER: return { show: true };

        default: return state;
    }
};
